<template>
 <div :class="windowClass">
   <v-container>
    <v-row>
      <v-col cols="12">
                <v-card>
               <v-toolbar>
                 <v-icon left color="primary">mdi-store</v-icon> Branches
                 <v-spacer/>
                 <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            dense
                            outlined
                            hide-details
                        ></v-text-field>
                 </span>
                 <v-divider vertical inset class="ml-5 mr-2"/>
                        <v-btn text small color="success" v-if="ALLOW('add_branch')"  @click="selecteditem={}, state='new', form=true"><v-icon small left color="success">mdi-plus</v-icon>  New</v-btn>
               </v-toolbar>
               <v-card-text>
                <v-data-table
                    class="va-table"
                    dense
                    :headers="headers"
                    :search="search"
                    :items="items"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                            <td>
                            <v-icon  x-small left color="warning" @click="selectedID=item.id, state='update', form=true" >mdi-pencil</v-icon>
                            {{ item.name }}</td>
                            <td>{{ item.franchisee }}</td>
                            <td>{{ item.address }}</td>
                            <td>{{ $moment(item.created_dt).format("MMM, DD YYYY hh:mm A") }}</td>
                             <td :class="STATUS_COLOR(item.status)">{{ item.status }}</td>
                              <td class="text-right">{{ $money(item.wallet) }}</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
               </v-card-text>
             </v-card>
          </v-col>
         
    </v-row>
    </v-container>
     <va-branch-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        search:"",
        selectedID:  null,
        trans_dailog: false,
        areaform: false,
        state: 'new',
        items:[],
        headers: [
            { text: 'Name', value:"name"},
            { text: 'Franchisee', value:"franchisee_id"},
            { text: 'Address', value:"address"},
            { text: 'Created' },
            { text: 'Status', value:"status"},
            { text: 'Wallet', value: "wallet", align: "right" }
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
    
      formEvent(){
          this.form = false
          this.getItems()
      },

      getItems: function() { 
        this.$http.get("branch/list").then(response => {
            response.data.list != null?this.items = response.data.list:this.items =[]
        }).catch(e => {
        console.log(e.data)
        })
     }
    }
  }
</script>